import { configureStore } from '@reduxjs/toolkit';
// import cartReducer from '../features/cart/cartSlice'; // подключим позже
const dummyReducer = () => ({});
export const store = configureStore({
  reducer: {
    // cart: cartReducer,
    dummy: dummyReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
